import { exponential } from './safe_math.js';

export const SECOND: number = 1
export const ZEPTOSECOND: number = exponential(SECOND, -21);
export const ATTOSECOND: number = exponential(SECOND, -18);
export const FEMTOSECOND: number = exponential(SECOND, -15);
export const PICOSECOND: number = exponential(SECOND, -12);
export const NANOSECOND: number = exponential(SECOND, -9);
export const MICROSECOND: number = exponential(SECOND, -6);
export const MILISECOND: number = exponential(SECOND, -3);
export const CENTISECOND: number = exponential(SECOND, -2);
export const DECISECOND: number = exponential(SECOND, -1);


export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const YEAR = 365 * DAY;
export const MONTH = YEAR / 12;

// Derived: explicit names
export const SECONDS_PER_MINUTE = MINUTE;
export const SECONDS_PER_HOUR = HOUR;
export const SECONDS_PER_DAY = DAY;
//math
export const PI = Math.PI
export const PI2 = 2 * PI


// Distance
export const METERS_PER_KM = 1000;
export const METERS_PER_MILE = 1609.34;
export const METERS_PER_FOOT = 0.3048;

export const KMS_PER_METER = 1 / METERS_PER_KM;
export const MILES_PER_METER = 1 / METERS_PER_MILE;
export const FEET_PER_METER = 1 / METERS_PER_FOOT;

export const MIN_IN_S = 1 / MINUTE;
export const HOUR_IN_S = 1 / HOUR;
export const DAY_IN_S = 1 / DAY;
export const YEAR_IN_S = 1 / YEAR;
export const MONTH_IN_S = 1 / MONTH;
export const MiPerH_TO_MPerS = METERS_PER_MILE * HOUR_IN_S;
export const MPerS_TO_MiPerH = 1 / MiPerH_TO_MPerS;


